/**
 * Rule S6 for new passwords, mirrored 1:1 from the backend (`PasswordService::ruleViolations`): at
 * least PASSWORD_MIN_LENGTH characters (code points, not UTF-16 units), an upper-case letter, a
 * lower-case letter and a digit 0-9 (ASCII on purpose: PHP's and JavaScript's `\d` differ for Unicode
 * digits). Both sides are tested against the same samples, backend/tests/Fixtures/password-rule-samples.json.
 * The backend checks again; this copy only spares the user a round trip.
 */
export const PASSWORD_MIN_LENGTH = 10;

/** How long the backend's brake locks an account after too many wrong passwords (PasswordAttemptGuard::LOCK_SECONDS); for the texts only. */
export const PASSWORD_LOCK_MINUTES = 15;

export type PasswordRuleViolation = 'length' | 'upper' | 'lower' | 'digit';

/** Which parts of rule S6 the password misses, in the backend's order; empty when it is met. */
export function passwordRuleViolations(password: string): PasswordRuleViolation[] {
    const violations: PasswordRuleViolation[] = [];
    if ([...password].length < PASSWORD_MIN_LENGTH) {
        violations.push('length');
    }
    if (!/\p{Lu}/u.test(password)) {
        violations.push('upper');
    }
    if (!/\p{Ll}/u.test(password)) {
        violations.push('lower');
    }
    if (!/[0-9]/.test(password)) {
        violations.push('digit');
    }

    return violations;
}
